import LoadPercentage from './LoadPercentage';

export {LoadPercentage};
